import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { BaseView, BaseText } from '@/components/base'
import { SavingItem } from './components/SavingItem'
import { EmptySavings } from './components/EmptySavings'
import { useFetchSavingGoals, AdaptedSavingGoalDTO } from '@/domain/transfer'

interface SavingsListProps {
  isLoading?: boolean
}

export const SavingsList: React.FC<SavingsListProps> = ({
  isLoading: externalLoading = false,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { data, isLoading: savingsIsLoading } = useFetchSavingGoals()
  const savings = data?.saving_goals || []

  // Combine external and internal loading states
  const isLoading = externalLoading || savingsIsLoading

  const handleSavingPress = (saving: AdaptedSavingGoalDTO) => {
    navigate(`/savings/savings-detail/${saving.id}`)
  }

  const handleEmptySavingsPress = () => {
    navigate('/savings')
  }

  return (
    <BaseView px={12} gap={12}>
      {/* Section Title - matching mobile: 16px medium */}
      <BaseText fontSize={16} fontFamily="medium" color="label.default">
        {t('screens:home.savings', { defaultValue: 'Savings' })}
      </BaseText>

      {/* Savings List or Empty State */}
      <BaseView gap={16}>
        {savings.length === 0 ? (
          <EmptySavings
            isLoading={isLoading}
            onPress={handleEmptySavingsPress}
          />
        ) : (
          savings.map((saving) => (
            <SavingItem
              key={saving.id}
              saving={saving}
              onPress={handleSavingPress}
            />
          ))
        )}
      </BaseView>
    </BaseView>
  )
}
